import * as S from './field-row.styled'
import type { FieldCategoryGridProps } from './field-row.types'

export const FieldCategoryGrid = ({ children, layout = 'columns' }: FieldCategoryGridProps) =>
  layout === 'rows' ? (
    <S.CategoryRowsGrid>{children}</S.CategoryRowsGrid>
  ) : (
    <S.CategoryGrid>{children}</S.CategoryGrid>
  )
